























































import {
    Component,
    Prop,
    Vue
} from 'vue-property-decorator';
import {
    pageDataType
} from "../../types";
import {
    HOST
} from "../../global";
@Component({
    name: "TabImgContent",
})
export default class TabImgContent extends Vue {
    @Prop() readonly compData!: any;
    public HOST: string = HOST;
    current = 0;

    clicktoggle() {

        const Navtab =
            (this.$refs.navwrap as HTMLElement) ||
            document.querySelector(".nav-wrap");
        const Btn =
            (this.$refs.togglebtn as HTMLElement) ||
            document.querySelector(".mb-tab");
        Btn.classList.toggle('active');
        Navtab.classList.toggle('add-transition');
    }
    // data() {
    //     return {
    //         current: 0,
    //         // active: 1,
    //         list: [{
    //                 text: 'Apparel',
    //                 content: 'this is text1',
    //                 images: require('../../assets/images/tabs.png')
    //             },
    //             {
    //                 text: 'Pharmaceuticals',
    //                 content: 'this is text2',
    //                 images: require('../../assets/images/a.png')
    //             },
    //             {
    //                 text: 'Retail',
    //                 content: 'this is text3',
    //                 images: require('../../assets/images/Image.png')
    //             },
    //             {
    //                 text: 'IT',
    //                 content: 'this is text4',
    //                 images: require('../../assets/images/Image.png')
    //             },
    //             {
    //                 text: 'Real Estate',
    //                 content: 'this is tex5',
    //                 images: require('../../assets/images/Image.png')
    //             }
    //         ]
    //     }
    // }

    itemClick(index: any) {
        if ((this as any).current == index) {
            (this as any).current = 0
        } else {
            (this as any).current = index
        }
    }
}
